import { convertDotsToUnderscores } from "./primeHelpers";
import { IPrimeParams } from "../interfaces";
import { IFilter } from "../components/pop-ups/advanceFilters/interfaces";

export interface IGenerateUrlParamsArguments extends Omit<IPrimeParams, "filters"> {
    page?: number;
    rows?: number;
    additionalParams?: string;
    filters?: IFilter[];
}

export const generateUrlParams = ({
    page = 1,
    rows = 10,
    multiSortMeta = undefined,
    filters = [],
    additionalParams = "",
}: IGenerateUrlParamsArguments): string => {
    let url = `?pageSize=${rows}&page=${page}`;

    if (multiSortMeta) {
        if (multiSortMeta[0].groupByThisField) {
            const grouping = multiSortMeta[0];
            url = url.concat(`&grouping=${grouping.order && grouping.order < 0 ? "-" : ""}${convertDotsToUnderscores(grouping.field)}&`);
        }

        multiSortMeta.forEach((sort, index) => {
            url = url.concat(
                `${index > 0 ? "," : "&ordering="}${sort.order && sort.order < 0 ? "-" : ""}${convertDotsToUnderscores(sort.field)}`
            );
        });

        url = url.concat("&");
    }

    if (filters?.length) {
        filters.forEach((filter, index) => {
            const { value, filterType, filterField } = filter;

            if (index != 0 && filter.operator == "OR") {
                url = url.concat("|");
            } else url = url.concat("&");

            if (typeof value != "string" && typeof value != "number") {
                const startDt = value?.[0];
                const endDt = value?.[1];

                if (endDt != null)
                    url = url.concat(
                        `search_field=${filterField}__date__gte&search=${startDt}&search_field=${filterField}__date__lte&search=${endDt}`
                    );
                else url = url.concat(`search_field=${filterField}__icontains&search=${startDt}`);
            } else url = url.concat(`search_field=${filterField}${filterType}&search=${value}`);
        });
    }

    if (additionalParams) {
        url += (additionalParams.startsWith("&") ? "" : "&") + additionalParams;
    }

    if (["&", "|"].includes(url[url.length - 1])) url = url.substring(0, url.length - 1);

    return url;
};
